import { Box, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

export interface GraphNoDataMessageProps {
  i18nKey?: string;
  defaultMessage?: string;
}

/** Shared empty state for charts and dashboard graph widgets. */
export function GraphNoDataMessage({ i18nKey = 'rawDataWidget.no-data', defaultMessage = 'No data to display' }: GraphNoDataMessageProps = {}) {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%" sx={{ px: 1, textAlign: 'center' }}>
      <Typography color="text.secondary" variant="body2">
        <Trans i18nKey={i18nKey}>{defaultMessage}</Trans>
      </Typography>
    </Box>
  );
}
